var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 655,
    height: 197,
    viewBox: "0 0 655 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M126.83 119.6c-3.45 0-6.15-.83-8.09-2.47-1.9-1.65-2.86-3.98-2.86-7 0-1.2.41-3.18 1.24-5.97l13.11-45.18c1.06-3.61 2.83-6.4 5.33-8.33 2.5-1.98 5.5-2.96 9.03-2.96 3.51 0 6.52.98 9.02 2.96 2.5 1.94 4.27 4.72 5.33 8.33l13.21 45.18c.76 2.5 1.14 4.55 1.14 6.16 0 2.93-.97 5.21-2.91 6.86-1.9 1.6-4.54 2.41-7.9 2.41a13 13 0 0 1-4.19-.59 6.56 6.56 0 0 1-2.9-1.83 12.09 12.09 0 0 1-1.88-2.6 37.4 37.4 0 0 1-1.53-3.66 6.41 6.41 0 0 0-1.23-2.36c-.43-.43-1.07-.65-1.92-.65h-8.49c-.82 0-1.44.22-1.87.64a7.6 7.6 0 0 0-1.23 2.37 23.56 23.56 0 0 1-2.27 4.93 8.18 8.18 0 0 1-3.1 2.77c-1.32.65-3 .98-5.04.98Zm19.78-26.98c.59 0 1.02-.15 1.28-.45.26-.33.31-.74.15-1.23l-3.45-19.43-3.56 19.33c-.2 1.18.28 1.78 1.44 1.78h4.14ZM189.22 119c-3.78 0-6.71-1.08-8.78-3.25-2.07-2.17-3.1-5.23-3.1-9.18V60.71c0-3.95 1.03-7 3.1-9.17 2.07-2.17 5-3.26 8.78-3.26h14.15c5.4-.1 9.67.51 12.82 1.82a19.22 19.22 0 0 1 8.98 7.16 18.98 18.98 0 0 1 2.07 17.2 8.21 8.21 0 0 1-1.33 2.33c-.63.82-1.05 1.36-1.28 1.62-.23.27-.74.74-1.53 1.43l-1.14 1.09c-.79.79-.79 1.43 0 1.92 1.35.79 2.5 1.6 3.45 2.42 1 .79 1.98 1.8 2.96 3.06a13.36 13.36 0 0 1 2.27 4.53c.53 1.74.8 3.72.8 5.92 0 6.28-2.16 11.28-6.47 15-4.17 3.48-10.34 5.22-18.5 5.22h-17.25Zm12.92-43c1.54 0 2.76-.46 3.65-1.38a5.24 5.24 0 0 0 1.33-3.8c0-1.61-.41-2.85-1.23-3.7a4.2 4.2 0 0 0-3.3-1.33h-.16c-2.2 0-3.3 1.03-3.3 3.1v4.44c0 1.78.97 2.67 2.9 2.67h.1Zm.3 26.13c1.8 0 3.22-.47 4.24-1.43a5.14 5.14 0 0 0 1.52-3.94c0-1.65-.46-2.94-1.38-3.9a4.74 4.74 0 0 0-3.65-1.43h-.1c-1.25 0-2.22.36-2.9 1.09a4.25 4.25 0 0 0-1.04 3.05v3.65c0 1.94 1.07 2.91 3.2 2.91h.1ZM280.6 115.5c-4.47 2.99-9.68 4.49-15.63 4.49-5.95 0-11.18-1.5-15.69-4.5-4.47-2.98-7.92-7.22-10.35-12.71-2.44-5.5-3.65-11.87-3.65-19.14 0-7.27 1.22-13.64 3.65-19.13 2.43-5.5 5.88-9.74 10.35-12.73 4.5-2.99 9.74-4.49 15.69-4.49 5.95 0 11.16 1.5 15.63 4.5 4.5 2.98 7.97 7.22 10.4 12.72 2.44 5.49 3.65 11.86 3.65 19.13s-1.21 13.64-3.64 19.14c-2.44 5.48-5.9 9.73-10.41 12.72Zm-15.63-15.29c2.3 0 4.1-1.46 5.42-4.39 1.35-2.96 2.02-7.02 2.02-12.18 0-5.1-.67-9.1-2.02-12.03-1.31-2.96-3.12-4.44-5.42-4.44-2.34 0-4.18 1.48-5.53 4.44-1.31 2.92-1.97 6.93-1.97 12.03 0 5.16.66 9.22 1.97 12.18 1.35 2.93 3.2 4.39 5.53 4.39ZM344.51 112.49c-4.8 5-11.2 7.5-19.23 7.5-8.02 0-14.46-2.5-19.33-7.5-4.83-5.03-7.25-11.72-7.25-20.07V59.13c0-3.58.97-6.38 2.9-8.38 1.95-2.04 4.63-3.06 8.05-3.06 3.42 0 6.08 1.02 7.99 3.06 1.94 2 2.9 4.8 2.9 8.38v33.93c0 1.77.43 3.19 1.29 4.24a4.3 4.3 0 0 0 3.45 1.58c1.41 0 2.53-.53 3.35-1.58a6.53 6.53 0 0 0 1.29-4.24V59.13c0-3.58.95-6.38 2.86-8.38 1.94-2.04 4.62-3.06 8.04-3.06 3.42 0 6.1 1.02 8.03 3.06 1.94 2 2.91 4.8 2.91 8.38v33.29c0 8.35-2.41 15.04-7.25 20.07ZM380.22 119.6c-3.39 0-6.07-1.11-8.04-3.31-1.97-2.24-2.96-5.28-2.96-9.13V72.15c0-1.78-1.03-2.66-3.1-2.66-3.43 0-6.14-.96-8.14-2.86-2-1.94-3.01-4.52-3.01-7.75 0-3.38 1.05-6 3.15-7.84 2.14-1.84 5.17-2.76 9.08-2.76h26.19c3.9 0 6.92.92 9.02 2.76 2.14 1.84 3.2 4.46 3.2 7.84 0 3.23-1 5.8-3 7.75-2 1.9-4.72 2.86-8.14 2.86-2.07 0-3.1.88-3.1 2.66v34.62c0 4.08-1 7.23-2.96 9.47-1.94 2.23-4.67 3.35-8.2 3.35ZM481.12 112.49c-4.8 5-11.21 7.5-19.23 7.5s-14.47-2.5-19.33-7.5c-4.84-5.03-7.25-11.72-7.25-20.07V59.13c0-3.58.97-6.38 2.9-8.38 1.94-2.04 4.63-3.06 8.04-3.06 3.42 0 6.09 1.02 8 3.06 1.93 2 2.9 4.8 2.9 8.38v33.93c0 1.77.43 3.19 1.29 4.24a4.3 4.3 0 0 0 3.45 1.58c1.41 0 2.53-.53 3.35-1.58a6.53 6.53 0 0 0 1.28-4.24V59.13c0-3.58.96-6.38 2.86-8.38 1.94-2.04 4.62-3.06 8.04-3.06 3.42 0 6.1 1.02 8.04 3.06 1.94 2 2.91 4.8 2.91 8.38v33.29c0 8.35-2.42 15.04-7.25 20.07ZM514.4 119.99c-6.37 0-11.68-1.58-15.92-4.74-3.85-2.86-5.77-6.43-5.77-10.7 0-2.73.79-4.96 2.37-6.7a7.59 7.59 0 0 1 5.92-2.67c1.31 0 2.58.26 3.8.79 1.2.5 2.18 1.05 2.9 1.68.76.62 1.58 1.2 2.47 1.72.89.5 1.72.74 2.51.74a3.2 3.2 0 0 0 2.37-.94c.66-.62.99-1.4.99-2.31 0-.96-.41-1.88-1.24-2.76-.82-.93-1.89-1.81-3.2-2.67-1.32-.85-2.76-1.76-4.34-2.71a51.75 51.75 0 0 1-4.78-3.4 35.61 35.61 0 0 1-4.35-4.3 19.07 19.07 0 0 1-3.2-5.76 22.28 22.28 0 0 1-1.23-7.55c0-6.18 2.07-11.13 6.21-14.84 4.18-3.72 9.71-5.58 16.62-5.58 4.18 0 7.74.68 10.7 2.03a13.62 13.62 0 0 1 5.67 4.29 9.98 9.98 0 0 1 2.02 6.11 8.5 8.5 0 0 1-2.16 5.97 7.12 7.12 0 0 1-5.43 2.32 9.84 9.84 0 0 1-4.73-1.43c-1.68-.96-2.93-1.43-3.75-1.43-.96 0-1.75.33-2.37.98a3.21 3.21 0 0 0-.94 2.37c0 1.02.41 1.97 1.24 2.86.82.89 1.89 1.73 3.2 2.52 1.32.78 2.76 1.62 4.34 2.51a32.9 32.9 0 0 1 9.08 7.35 18.13 18.13 0 0 1 3.2 5.87c.82 2.36 1.23 5 1.23 7.89 0 6.8-2.13 12.26-6.4 16.37-4.25 4.08-9.92 6.12-17.02 6.12Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M38.76 24.18c.25-1.14 2.46-1.14 2.7 0 1.55 7 4.5 17.15 9.35 22.01 4.86 4.86 15 7.8 22 9.34 1.15.25 1.15 2.46 0 2.71-7 1.54-17.14 4.49-22 9.34-4.78 4.79-7.71 14.7-9.27 21.7-.26 1.14-2.55 1.13-2.8-.02-1.5-6.93-4.4-16.75-9.32-21.68-4.93-4.93-14.75-7.82-21.68-9.32-1.15-.25-1.16-2.54-.01-2.8 6.99-1.56 16.9-4.49 21.69-9.27 4.85-4.86 7.8-15 9.34-22Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M38.76 24.18c.25-1.14 2.46-1.14 2.7 0 1.55 7 4.5 17.15 9.35 22.01 4.86 4.86 15 7.8 22 9.34 1.15.25 1.15 2.46 0 2.71-7 1.54-17.14 4.49-22 9.34-4.78 4.79-7.71 14.7-9.27 21.7-.26 1.14-2.55 1.13-2.8-.02-1.5-6.93-4.4-16.75-9.32-21.68-4.93-4.93-14.75-7.82-21.68-9.32-1.15-.25-1.16-2.54-.01-2.8 6.99-1.56 16.9-4.49 21.69-9.27 4.85-4.86 7.8-15 9.34-22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m7.74 58.26-.32 1.46.32-1.46Zm-.01-2.8L7.4 54l.33 1.46Zm33.81 33.81-1.46-.32 1.46.32Zm31.28-31.03.32 1.47-.32-1.47Zm-.32-1.46a86.43 86.43 0 0 0-12.03 3.49c-4.08 1.56-8.07 3.6-10.72 6.25l2.12 2.12c2.2-2.2 5.72-4.06 9.67-5.57 3.93-1.5 8.14-2.6 11.6-3.36l-.64-2.93Zm-22.75 9.74c-2.62 2.62-4.63 6.53-6.18 10.54a85.22 85.22 0 0 0-3.5 11.89l2.93.65c.77-3.46 1.88-7.6 3.36-11.46 1.5-3.89 3.34-7.33 5.51-9.5l-2.12-2.12Zm-9.54 22.42a81 81 0 0 0-3.45-11.81c-1.55-4-3.6-7.92-6.28-10.6l-2.12 2.11c2.24 2.25 4.1 5.7 5.6 9.57a78.04 78.04 0 0 1 3.32 11.37l2.93-.64Zm-9.73-22.42c-2.69-2.68-6.6-4.73-10.6-6.28a81.01 81.01 0 0 0-11.82-3.45l-.64 2.93c3.42.75 7.53 1.83 11.37 3.31 3.86 1.5 7.32 3.37 9.57 5.61l2.12-2.12Zm-22.43-9.6a85.24 85.24 0 0 0 11.9-3.49c4-1.54 7.91-3.56 10.53-6.18l-2.12-2.12c-2.17 2.17-5.61 4-9.5 5.5-3.85 1.5-8 2.6-11.46 3.37l.65 2.92Zm22.43-9.67c2.65-2.65 4.7-6.64 6.25-10.72a86.45 86.45 0 0 0 3.5-12.03l-2.94-.64a83.46 83.46 0 0 1-3.36 11.6c-1.51 3.95-3.37 7.47-5.57 9.67l2.12 2.12ZM40 24.5a86.45 86.45 0 0 0 3.5 12.03c1.55 4.08 3.6 8.07 6.25 10.72l2.12-2.12c-2.2-2.2-4.06-5.72-5.57-9.67a83.46 83.46 0 0 1-3.37-11.6L40 24.5Zm9.75 22.75c2.65 2.65 6.64 4.7 10.72 6.26A86.42 86.42 0 0 0 72.5 57l.64-2.93a83.46 83.46 0 0 1-11.6-3.37c-3.95-1.5-7.47-3.37-9.67-5.57l-2.12 2.12ZM8.05 56.8a.6.6 0 0 1 .25.12l.1.1-.01-.03a.54.54 0 0 1 0-.25v-.03c0 .01-.03.06-.09.1a.6.6 0 0 1-.25.12L7.4 54c-.8.17-1.32.7-1.62 1.24-.3.52-.41 1.1-.4 1.63 0 .52.11 1.1.4 1.62.31.54.84 1.06 1.64 1.23l.64-2.93Zm32.03 32.16a.6.6 0 0 1 .11-.25l.1-.1c.02 0 .01 0-.02.02a.55.55 0 0 1-.25 0L40 88.6c.01 0 .06.03.1.09a.58.58 0 0 1 .12.24l-2.93.64c.17.8.7 1.33 1.23 1.63.52.3 1.1.42 1.62.42.53 0 1.11-.11 1.63-.4.54-.3 1.07-.84 1.24-1.63l-2.92-.65ZM73.14 59.7c1.6-.35 2.03-1.93 2.03-2.82 0-.9-.43-2.47-2.03-2.82L72.5 57a.59.59 0 0 1-.24-.12.4.4 0 0 1-.1-.1c0-.02 0-.02 0 0a.43.43 0 0 1 0 .2V57a.4.4 0 0 1 .1-.11c.07-.05.15-.1.24-.11l.64 2.93ZM40.22 24.5a.59.59 0 0 1-.1.23.4.4 0 0 1-.12.1h.02a.43.43 0 0 1 .2 0c.02 0 .02 0 0 0a.4.4 0 0 1-.1-.1.59.59 0 0 1-.12-.24l2.93-.64c-.35-1.6-1.92-2.03-2.82-2.03-.89 0-2.47.43-2.82 2.03l2.93.64Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M73.66 7.36c.32-1.12 2.83-1.12 3.15 0 .93 3.25 2.32 6.76 4.27 8.71 1.95 1.95 5.46 3.34 8.7 4.27 1.13.32 1.13 2.83 0 3.15-3.24.93-6.75 2.32-8.7 4.27-1.89 1.89-3.25 5.24-4.18 8.4-.33 1.12-2.96 1.11-3.3-.02-.9-3.12-2.27-6.44-4.21-8.38-1.94-1.94-5.26-3.3-8.38-4.22-1.13-.33-1.14-2.96-.01-3.3 3.15-.92 6.5-2.28 8.39-4.17 1.95-1.95 3.34-5.46 4.27-8.7Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M73.66 7.36c.32-1.12 2.82-1.12 3.15 0 .93 3.25 2.31 6.76 4.26 8.7 1.95 1.96 5.47 3.34 8.71 4.28 1.12.32 1.12 2.82 0 3.15-3.24.93-6.76 2.31-8.7 4.26-1.9 1.89-3.25 5.24-4.18 8.4-.33 1.12-2.96 1.1-3.3-.02-.91-3.12-2.27-6.44-4.21-8.38-1.94-1.93-5.26-3.3-8.38-4.21-1.13-.33-1.14-2.96 0-3.3 3.14-.93 6.5-2.29 8.38-4.17 1.95-1.95 3.34-5.46 4.27-8.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m61.01 23.54.42-1.44-.42 1.44Zm15.89 12.6 1.44.43-1.44-.43ZM89.78 23.5l-.41-1.45.41 1.45Zm-.41-1.45c-3.26.94-7.1 2.4-9.36 4.65l2.13 2.12c1.65-1.65 4.82-2.95 8.05-3.88l-.82-2.89ZM80 26.7c-2.17 2.18-3.62 5.86-4.55 9.03l2.88.85c.92-3.14 2.2-6.16 3.8-7.76L80 26.7Zm-4.97 9.02c-.92-3.15-2.37-6.8-4.6-9.02l-2.11 2.12c1.65 1.66 2.93 4.65 3.84 7.75l2.87-.85Zm-4.6-9.02c-2.22-2.22-5.86-3.67-9-4.6l-.85 2.89c3.09.9 6.09 2.18 7.74 3.83l2.12-2.12Zm-9.01-5c3.17-.94 6.84-2.38 9.02-4.56L68.33 15c-1.6 1.6-4.62 2.87-7.75 3.8l.85 2.87Zm9.02-4.56c2.25-2.25 3.71-6.1 4.65-9.35l-2.88-.83c-.93 3.23-2.24 6.4-3.9 8.06l2.13 2.12Zm4.91-9.35c.94 3.25 2.4 7.1 4.65 9.35L82.14 15c-1.66-1.66-2.96-4.83-3.9-8.06l-2.88.83Zm4.65 9.35c2.25 2.25 6.1 3.71 9.36 4.65l.82-2.89c-3.23-.92-6.4-2.23-8.05-3.88L80 17.13ZM61.43 22.1c.27.08.33.25.3.19a1.3 1.3 0 0 1 0-.8c.03-.06-.04.11-.3.2l-.85-2.89c-.83.25-1.32.88-1.57 1.41a3.97 3.97 0 0 0-.35 1.68c0 .55.1 1.14.36 1.68.25.53.74 1.16 1.57 1.4l.84-2.87Zm14.03 13.62c.08-.27.26-.33.2-.3a.66.66 0 0 1-.15.04 1.3 1.3 0 0 1-.65-.05c-.07-.03.1.03.18.3l-2.87.85c.24.82.87 1.31 1.4 1.56.54.26 1.14.36 1.68.36s1.14-.1 1.68-.35a2.55 2.55 0 0 0 1.4-1.56l-2.87-.85Zm14.73-10.8c.81-.23 1.3-.82 1.57-1.36.26-.53.36-1.12.36-1.65 0-.53-.1-1.12-.36-1.65a2.54 2.54 0 0 0-1.57-1.37l-.82 2.89a.61.61 0 0 1-.25-.14l-.05-.06.03.12a1.07 1.07 0 0 1-.03.54l.05-.06c.05-.05.13-.1.25-.14l.82 2.89ZM75.1 7.79c-.02.11-.08.2-.13.25l-.06.05c.02-.01.05-.03.12-.04a1.07 1.07 0 0 1 .54.04c.02 0-.01 0-.06-.05a.61.61 0 0 1-.14-.25l2.89-.83a2.54 2.54 0 0 0-1.36-1.57 3.78 3.78 0 0 0-1.66-.36c-.53 0-1.12.1-1.65.36-.53.27-1.13.76-1.36 1.57l2.88.83Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M595.76 86.18c.25-1.14 2.46-1.14 2.7 0 1.55 7 4.5 17.15 9.35 22.01 4.86 4.86 15 7.8 22 9.34 1.15.25 1.15 2.46 0 2.71-7 1.54-17.14 4.49-22 9.34-4.78 4.79-7.71 14.7-9.27 21.7-.26 1.14-2.55 1.13-2.8-.02-1.5-6.93-4.4-16.75-9.32-21.68-4.93-4.93-14.75-7.82-21.68-9.32-1.15-.25-1.16-2.54-.01-2.8 6.99-1.56 16.9-4.49 21.69-9.27 4.85-4.86 7.8-15 9.34-22Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M595.76 86.18c.25-1.14 2.46-1.14 2.7 0 1.55 7 4.5 17.15 9.35 22.01 4.86 4.86 15 7.8 22 9.34 1.15.25 1.15 2.46 0 2.71-7 1.54-17.14 4.49-22 9.34-4.78 4.79-7.71 14.7-9.27 21.7-.26 1.14-2.55 1.13-2.8-.02-1.5-6.93-4.4-16.75-9.32-21.68-4.93-4.93-14.75-7.82-21.68-9.32-1.15-.25-1.16-2.54-.01-2.8 6.99-1.56 16.9-4.49 21.69-9.27 4.85-4.86 7.8-15 9.34-22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m564.74 120.26-.32 1.46.32-1.46Zm-.01-2.8-.33-1.46.33 1.46Zm33.81 33.81-1.46-.32 1.46.32Zm31.28-31.03.32 1.47-.32-1.47Zm-.32-1.46a86.54 86.54 0 0 0-12.03 3.49c-4.08 1.56-8.07 3.6-10.72 6.25l2.12 2.12c2.2-2.2 5.72-4.06 9.67-5.57 3.93-1.5 8.14-2.6 11.6-3.36l-.64-2.93Zm-22.75 9.74c-2.62 2.62-4.63 6.53-6.18 10.54a85.43 85.43 0 0 0-3.5 11.89l2.93.65c.77-3.46 1.88-7.6 3.36-11.46 1.5-3.89 3.34-7.33 5.51-9.5l-2.12-2.12Zm-9.54 22.42a80.94 80.94 0 0 0-3.45-11.81c-1.55-4-3.6-7.92-6.28-10.6l-2.12 2.11c2.24 2.25 4.1 5.7 5.6 9.58a78.07 78.07 0 0 1 3.32 11.36l2.93-.64Zm-9.73-22.42c-2.69-2.68-6.6-4.73-10.6-6.28a80.94 80.94 0 0 0-11.82-3.45l-.64 2.93a78.1 78.1 0 0 1 11.37 3.31c3.86 1.5 7.32 3.37 9.57 5.61l2.12-2.12Zm-22.43-9.6a85.2 85.2 0 0 0 11.9-3.48c4-1.55 7.91-3.58 10.53-6.19l-2.12-2.12c-2.17 2.17-5.61 4-9.5 5.5-3.86 1.5-8 2.6-11.46 3.37l.65 2.92Zm22.43-9.67c2.65-2.65 4.7-6.64 6.25-10.72a86.4 86.4 0 0 0 3.5-12.03l-2.94-.64a83.53 83.53 0 0 1-3.36 11.6c-1.51 3.95-3.37 7.47-5.57 9.67l2.12 2.12ZM597 86.5a86.27 86.27 0 0 0 3.5 12.03c1.55 4.08 3.6 8.07 6.25 10.72l2.12-2.12c-2.2-2.2-4.06-5.72-5.57-9.67a83.4 83.4 0 0 1-3.37-11.6l-2.93.64Zm9.75 22.75c2.65 2.66 6.64 4.7 10.72 6.26A86.54 86.54 0 0 0 629.5 119l.64-2.93a83.38 83.38 0 0 1-11.6-3.37c-3.95-1.5-7.47-3.37-9.67-5.57l-2.12 2.12Zm-41.7 9.54a.6.6 0 0 1 .25.12l.1.1-.01-.03a.51.51 0 0 1 0-.25v-.03c0 .01-.03.06-.09.1a.57.57 0 0 1-.25.13l-.65-2.93c-.8.17-1.32.7-1.63 1.24-.29.52-.4 1.1-.4 1.63 0 .52.12 1.1.42 1.62.3.54.83 1.06 1.63 1.23l.64-2.93Zm32.03 32.16c0-.05.02-.1.04-.14a.67.67 0 0 1 .07-.11.4.4 0 0 1 .1-.1c.02 0 .01 0-.02.02a.52.52 0 0 1-.25 0l-.03-.01c.01 0 .05.03.1.09l.07.1.05.14-2.93.64c.17.8.7 1.33 1.23 1.63.52.3 1.1.42 1.62.42.53 0 1.11-.11 1.63-.4.54-.3 1.07-.84 1.24-1.63l-2.92-.65Zm33.06-29.24c1.6-.35 2.03-1.93 2.03-2.82 0-.9-.43-2.47-2.03-2.82l-.64 2.93a.6.6 0 0 1-.24-.12.39.39 0 0 1-.1-.1c0-.02 0-.02 0 0a.41.41 0 0 1 0 .2v.02a.4.4 0 0 1 .1-.11.6.6 0 0 1 .24-.11l.64 2.93Zm-32.92-35.2a.6.6 0 0 1-.1.23.4.4 0 0 1-.12.1h.01a.44.44 0 0 1 .2 0h.01a.4.4 0 0 1-.1-.1.58.58 0 0 1-.12-.24l2.93-.64c-.35-1.6-1.92-2.03-2.82-2.03-.89 0-2.47.43-2.82 2.03l2.93.64Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M630.66 69.36c.32-1.12 2.83-1.12 3.15 0 .93 3.25 2.32 6.76 4.27 8.71 1.95 1.95 5.46 3.34 8.7 4.27 1.13.32 1.13 2.83 0 3.15-3.24.93-6.75 2.32-8.7 4.27-1.89 1.89-3.25 5.24-4.18 8.4-.33 1.12-2.96 1.11-3.3-.02-.9-3.12-2.27-6.44-4.21-8.38-1.94-1.94-5.26-3.3-8.38-4.22-1.13-.33-1.14-2.96-.01-3.3 3.15-.92 6.5-2.28 8.39-4.17 1.95-1.95 3.34-5.46 4.27-8.7Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M630.66 69.36c.32-1.12 2.82-1.12 3.15 0 .93 3.25 2.31 6.76 4.26 8.7 1.95 1.96 5.47 3.34 8.71 4.28 1.12.32 1.12 2.82 0 3.15-3.24.93-6.75 2.31-8.7 4.26-1.9 1.89-3.25 5.24-4.18 8.4-.33 1.12-2.96 1.1-3.3-.02-.91-3.12-2.27-6.44-4.21-8.38-1.94-1.93-5.26-3.3-8.38-4.21-1.13-.33-1.13-2.96 0-3.3 3.14-.93 6.5-2.29 8.38-4.17 1.95-1.95 3.34-5.46 4.27-8.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m618.01 85.54.42-1.44-.42 1.44Zm15.89 12.6 1.44.43-1.44-.43Zm12.88-12.65-.41-1.45.41 1.45Zm-.41-1.45c-3.26.94-7.1 2.4-9.36 4.65l2.13 2.12c1.65-1.65 4.82-2.95 8.05-3.88l-.82-2.89ZM637 88.7c-2.17 2.18-3.62 5.86-4.55 9.03l2.88.85c.92-3.14 2.2-6.16 3.8-7.76L637 88.7Zm-4.97 9.02c-.92-3.15-2.37-6.8-4.6-9.02l-2.11 2.12c1.65 1.66 2.93 4.65 3.84 7.75l2.88-.85Zm-4.6-9.02c-2.22-2.22-5.86-3.67-9-4.6l-.85 2.89c3.09.9 6.09 2.18 7.74 3.83l2.12-2.12Zm-9.01-5c3.17-.94 6.84-2.38 9.02-4.56L625.33 77c-1.6 1.6-4.62 2.87-7.75 3.8l.85 2.87Zm9.02-4.56c2.25-2.25 3.71-6.1 4.65-9.35l-2.88-.83c-.93 3.23-2.24 6.4-3.9 8.06l2.13 2.12Zm4.91-9.35c.94 3.25 2.4 7.1 4.65 9.35l2.13-2.12c-1.66-1.66-2.96-4.83-3.9-8.06l-2.88.83Zm4.65 9.35c2.25 2.25 6.1 3.71 9.36 4.65l.82-2.89c-3.23-.92-6.4-2.23-8.06-3.88l-2.12 2.12Zm-18.58 4.97c.27.08.33.25.3.19a.65.65 0 0 1-.05-.15 1.37 1.37 0 0 1 0-.5.63.63 0 0 1 .05-.15c.03-.06-.04.11-.3.2l-.85-2.89c-.83.25-1.32.88-1.57 1.41a3.98 3.98 0 0 0-.35 1.68c0 .55.1 1.14.36 1.68.25.53.74 1.16 1.57 1.4l.84-2.87Zm14.03 13.62c.08-.27.26-.33.2-.3a.65.65 0 0 1-.15.04 1.3 1.3 0 0 1-.65-.05c-.07-.03.1.03.18.3l-2.87.85c.24.82.87 1.31 1.4 1.56a4 4 0 0 0 1.68.36c.54 0 1.14-.1 1.68-.35a2.55 2.55 0 0 0 1.4-1.56l-2.87-.85Zm14.73-10.8c.81-.23 1.3-.82 1.57-1.36.26-.53.36-1.12.36-1.65 0-.53-.1-1.12-.36-1.65a2.54 2.54 0 0 0-1.57-1.37l-.82 2.89a.62.62 0 0 1-.25-.14l-.05-.06.03.12a1.07 1.07 0 0 1-.03.54l.04-.06c.06-.05.14-.1.26-.14l.82 2.89Zm-15.1-17.14c-.02.11-.08.2-.13.25l-.06.05c.02-.01.05-.03.12-.04a1.08 1.08 0 0 1 .54.04c.02 0-.01 0-.06-.05a.62.62 0 0 1-.13-.25l2.88-.83a2.54 2.54 0 0 0-1.36-1.57 3.79 3.79 0 0 0-1.66-.36c-.53 0-1.12.1-1.65.36-.54.27-1.13.76-1.37 1.57l2.89.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M342.66 154.88a41.83 41.83 0 1 1-83.66 0 41.83 41.83 0 0 1 83.66 0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M288.01 137a4.25 4.25 0 0 1 8.35 1.62l1.69.33a5.97 5.97 0 1 0-11.72-2.28l1.68.33ZM317.87 160.03c-4.7.3-11.04-.28-17.88-1.79s-12.82-3.67-16.96-5.92a18.9 18.9 0 0 1-4.63-3.29c-1.01-1.07-1.26-1.88-1.13-2.44l-1.68-.37c-.32 1.41.42 2.8 1.56 4a20.57 20.57 0 0 0 5.06 3.62c4.32 2.34 10.46 4.54 17.41 6.08 6.95 1.54 13.45 2.13 18.35 1.83 2.45-.15 4.55-.53 6.12-1.15 1.54-.6 2.79-1.55 3.1-2.96l-1.68-.37c-.12.56-.69 1.2-2.05 1.73-1.34.53-3.23.89-5.6 1.03Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M390.22 154.88a41.87 41.87 0 1 1-83.75 0 41.87 41.87 0 0 1 83.75 0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M392.36 154c.25.25.25.67 0 .93l-1.93 1.92-7.17-7.17 1.92-1.92a.66.66 0 0 1 .94 0l6.24 6.24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M392.7 153.65c.45.45.45 1.18 0 1.63l-2.27 2.27-7.87-7.87 2.27-2.27a1.16 1.16 0 0 1 1.64 0l6.23 6.24Zm-.7.93a.17.17 0 0 0 0-.24l-6.23-6.23a.16.16 0 0 0-.24 0l-1.57 1.57 6.47 6.47 1.57-1.57Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M350.48 183.5a.66.66 0 0 1 0-.93l1.92-1.92 7.17 7.17-1.92 1.93a.66.66 0 0 1-.94 0l-6.23-6.24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M350.13 183.86a1.16 1.16 0 0 1 0-1.63l2.27-2.28 7.87 7.87-2.27 2.28c-.45.45-1.19.45-1.64 0l-6.24-6.24Zm.7-.94a.17.17 0 0 0 0 .24l6.23 6.24c.07.06.17.06.24 0l1.57-1.58-6.47-6.47-1.57 1.58Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M391.56 157.18c.26.26.26.68 0 .94l-2.32 2.32-9.56-9.56 2.32-2.33a.66.66 0 0 1 .93 0l8.63 8.63Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M391.9 156.83c.46.45.46 1.18 0 1.63l-2.66 2.68-10.26-10.26 2.67-2.68a1.16 1.16 0 0 1 1.63 0l8.63 8.63Zm-.7.93a.16.16 0 0 0 0-.23l-8.62-8.63a.16.16 0 0 0-.23 0l-1.98 1.98 8.87 8.86 1.97-1.98Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M351.27 180.32a.66.66 0 0 1 0-.93l2.32-2.32 9.57 9.56-2.33 2.32a.66.66 0 0 1-.93 0l-8.63-8.63Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M350.92 180.67a1.16 1.16 0 0 1 0-1.63l2.67-2.67 10.27 10.26-2.68 2.67c-.45.45-1.18.45-1.63 0l-8.63-8.63Zm.7-.93a.16.16 0 0 0 0 .23l8.63 8.63c.06.06.17.06.23 0l1.98-1.97-8.87-8.87-1.97 1.98Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m385.48 156.34-26.3 26.3-1.6-1.59 26.3-26.3 1.6 1.59Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M377.1 165.1a8.66 8.66 0 0 1 0 17.35H366.8a1.3 1.3 0 0 1 0-2.62h5.89v-1.06h-9.57a1.3 1.3 0 0 1 0-2.62h8.1v-1.06h-9.58a1.3 1.3 0 1 1 0-2.62h9.57v-1.06h-7.73a1.3 1.3 0 1 1 0-2.62h12.7v-1.06h-4.97a1.3 1.3 0 1 1 0-2.62v-1.07a2.37 2.37 0 0 0-1.98 3.69h-5.75a2.37 2.37 0 0 0-1.97 3.68 2.37 2.37 0 0 0-.34 4.7 2.37 2.37 0 0 0 1.95 3.73h1.7a2.37 2.37 0 0 0 1.98 3.68h10.32a9.73 9.73 0 0 0 0-19.48h-5.9v1.07h5.9Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M377.1 165.1a8.66 8.66 0 0 1 0 17.35H366.8a1.3 1.3 0 0 1 0-2.62h5.89v-1.06h-9.57a1.3 1.3 0 0 1 0-2.62h8.1v-1.06h-9.58a1.3 1.3 0 1 1 0-2.62h9.57v-1.06h-7.73a1.3 1.3 0 1 1 0-2.62h12.7v-1.06h-4.97a1.3 1.3 0 1 1 0-2.62h5.9Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M330.1 171.9a8.66 8.66 0 0 1-10.01 14.17l-8.43-5.96a1.3 1.3 0 0 1 1.51-2.14l4.81 3.4.62-.87-4.81-3.4-3.01-2.12a1.3 1.3 0 0 1 1.5-2.14h.01l6.61 4.68.62-.87-6.62-4.68-1.2-.84a1.3 1.3 0 0 1 1.51-2.14l1.5 1.06 6.32 4.46.61-.87-6.31-4.46a1.3 1.3 0 0 1 1.51-2.14l6.31 4.47 4.06 2.86.62-.86-4.06-2.87a1.3 1.3 0 1 1 1.5-2.14l.62-.87a2.37 2.37 0 0 0-3.74 1.87l-4.7-3.32a2.37 2.37 0 0 0-3.74 1.86 2.37 2.37 0 0 0-2.98 3.64 2.37 2.37 0 0 0-.56 4.17l1.38.98a2.37 2.37 0 0 0-.5 4.15l8.43 5.96a9.73 9.73 0 0 0 11.23-15.9l-4.82-3.4-.61.86 4.82 3.4Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M330.1 171.9a8.66 8.66 0 0 1-10.01 14.17l-8.43-5.96a1.3 1.3 0 0 1 1.51-2.14l4.81 3.4.62-.87-4.81-3.4-3.01-2.12a1.3 1.3 0 0 1 1.5-2.14h.01l6.61 4.68.62-.87-6.62-4.68-1.2-.84a1.3 1.3 0 0 1 1.51-2.14l1.5 1.06 6.32 4.46.61-.87-6.31-4.46a1.3 1.3 0 0 1 1.51-2.14l6.31 4.47 4.06 2.86.62-.86-4.06-2.87a1.3 1.3 0 1 1 1.5-2.14l4.83 3.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M319.36 174.78a9.22 9.22 0 1 1-13.78-12.26 9.22 9.22 0 0 1 13.78 12.26Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M318.49 161.89a9.05 9.05 0 1 0-12.04 13.52 9.05 9.05 0 0 0 12.04-13.52Zm-13.03.52a9.38 9.38 0 1 1 14.02 12.48 9.38 9.38 0 0 1-14.02-12.48Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M306.67 175.17a8.72 8.72 0 1 0 11.6-13.04 8.72 8.72 0 0 0-11.6 13.04Zm-.33.37a9.22 9.22 0 1 0 12.26-13.78 9.22 9.22 0 0 0-12.26 13.78Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M318.49 161.89a9.05 9.05 0 1 0-12.04 13.52 9.05 9.05 0 0 0 12.04-13.52Zm-13.03.52a9.38 9.38 0 1 1 14.02 12.48 9.38 9.38 0 0 1-14.02-12.48Zm12.7-.15a8.56 8.56 0 1 0-11.38 12.78 8.56 8.56 0 0 0 11.38-12.78Zm-12.33.48a8.89 8.89 0 1 1 13.28 11.82 8.89 8.89 0 0 1-13.28-11.82Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M311.2 175.89a11.5 11.5 0 0 0 5.43-3.54 11.51 11.51 0 0 0 2.88-5.8c.28-1.86-.16-3.45-1.25-4.41-1.08-.97-2.7-1.22-4.53-.73-1.83.5-3.78 1.7-5.42 3.54a11.5 11.5 0 0 0-2.89 5.8c-.27 1.87.16 3.45 1.25 4.42 1.09.96 2.71 1.21 4.54.72Zm-4.86-.35c2.5 2.22 7.27.95 10.66-2.86 3.38-3.8 4.1-8.7 1.6-10.92-2.5-2.22-7.28-.94-10.66 2.86-3.39 3.8-4.1 8.7-1.6 10.92Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M313.64 161.09c-1.9.5-3.9 1.76-5.58 3.64a11.84 11.84 0 0 0-2.97 5.97c-.28 1.94.16 3.65 1.36 4.72 1.2 1.06 2.95 1.3 4.84.8 1.9-.51 3.91-1.77 5.58-3.65a11.84 11.84 0 0 0 2.97-5.96c.29-1.95-.16-3.66-1.35-4.72-1.2-1.07-2.95-1.3-4.85-.8Zm-.08-.32c1.96-.52 3.84-.3 5.14.87 1.31 1.16 1.76 3 1.47 5.01a12.17 12.17 0 0 1-3.05 6.14 12.16 12.16 0 0 1-5.74 3.74c-1.96.53-3.84.3-5.15-.87-1.3-1.16-1.76-3-1.46-5.01.3-2.01 1.33-4.22 3.04-6.14a12.17 12.17 0 0 1 5.75-3.74Zm4.6 1.49c-1.04-.92-2.6-1.17-4.4-.69a11.35 11.35 0 0 0-5.33 3.5 11.34 11.34 0 0 0-2.84 5.7c-.27 1.83.16 3.36 1.19 4.27 1.03.92 2.6 1.17 4.39.7a11.35 11.35 0 0 0 5.33-3.5 11.35 11.35 0 0 0 2.85-5.7c.27-1.84-.17-3.36-1.2-4.28Zm-4.48-1c1.87-.5 3.55-.26 4.7.75 1.13 1.02 1.57 2.67 1.3 4.57a11.68 11.68 0 0 1-2.93 5.88 11.67 11.67 0 0 1-5.5 3.59c-1.86.5-3.55.25-4.69-.76-1.14-1.01-1.58-2.66-1.3-4.57.28-1.9 1.27-4.02 2.93-5.88a11.67 11.67 0 0 1 5.5-3.59Z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M319.7 169.91a11.5 11.5 0 0 0-3.53-5.42 11.5 11.5 0 0 0-5.8-2.88c-1.87-.28-3.45.16-4.42 1.24-.96 1.09-1.21 2.72-.72 4.54.49 1.82 1.7 3.78 3.54 5.42a11.5 11.5 0 0 0 5.79 2.88c1.87.28 3.46-.16 4.42-1.24.97-1.09 1.22-2.71.73-4.54Zm-.34 4.87c2.22-2.5.94-7.27-2.86-10.66-3.8-3.38-8.7-4.1-10.92-1.6-2.23 2.5-.95 7.28 2.86 10.66 3.8 3.38 8.69 4.1 10.92 1.6Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M304.9 167.48c.51 1.9 1.77 3.9 3.65 5.58a11.84 11.84 0 0 0 5.96 2.96c1.94.29 3.66-.15 4.72-1.35 1.07-1.2 1.3-2.95.8-4.85-.5-1.89-1.76-3.9-3.64-5.58a11.84 11.84 0 0 0-5.97-2.96c-1.94-.29-3.65.16-4.72 1.35-1.06 1.2-1.3 2.95-.8 4.85Zm-.31.08c-.53-1.96-.3-3.84.87-5.15 1.16-1.3 3-1.75 5.01-1.46 2.01.3 4.21 1.34 6.14 3.05a12.17 12.17 0 0 1 3.74 5.74c.52 1.96.29 3.84-.87 5.15-1.16 1.3-3 1.76-5.02 1.46a12.16 12.16 0 0 1-6.13-3.05 12.17 12.17 0 0 1-3.74-5.74Zm1.49-4.6c-.92 1.03-1.17 2.6-.7 4.39a11.34 11.34 0 0 0 3.5 5.34 11.34 11.34 0 0 0 5.7 2.84c1.84.27 3.36-.16 4.28-1.2.92-1.02 1.17-2.58.69-4.38a11.34 11.34 0 0 0-3.5-5.33 11.34 11.34 0 0 0-5.7-2.85c-1.84-.27-3.36.16-4.28 1.2Zm-1.01 4.47c-.5-1.86-.26-3.55.76-4.69 1.01-1.14 2.66-1.57 4.57-1.3 1.9.28 4.02 1.28 5.88 2.93a11.67 11.67 0 0 1 3.59 5.5c.5 1.86.25 3.55-.76 4.69-1.02 1.14-2.67 1.58-4.57 1.3a11.66 11.66 0 0 1-5.88-2.93 11.67 11.67 0 0 1-3.6-5.5Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M309.33 174.4c1.42-.9 3.14-2.38 4.81-4.26a24.1 24.1 0 0 0 3.68-5.27c.36-.76.57-1.4.63-1.89.07-.5-.04-.71-.12-.79-.09-.08-.31-.16-.8-.03a6.6 6.6 0 0 0-1.8.85c-1.42.9-3.14 2.38-4.81 4.26a24.1 24.1 0 0 0-3.68 5.27c-.36.76-.57 1.4-.64 1.89-.06.5.05.71.13.8.09.07.31.15.8.03a6.6 6.6 0 0 0 1.8-.86Zm-2.93 1.2c1.1.97 4.73-1.32 8.12-5.13 3.38-3.8 5.23-7.68 4.14-8.65-1.1-.98-4.73 1.31-8.12 5.12-3.38 3.8-5.24 7.68-4.14 8.65Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M315.55 162.73c-1.45.91-3.2 2.43-4.88 4.32a24.45 24.45 0 0 0-3.73 5.35c-.37.77-.6 1.45-.67 1.99-.07.54.03.9.24 1.08.21.19.58.24 1.1.11a6.93 6.93 0 0 0 1.9-.9c1.45-.91 3.2-2.42 4.88-4.32 1.69-1.9 2.99-3.8 3.73-5.35.37-.77.6-1.45.67-1.98.07-.55-.03-.9-.24-1.09-.21-.19-.58-.24-1.1-.1-.53.12-1.18.43-1.9.89Zm1.81-1.22c.57-.14 1.07-.11 1.4.19.34.3.43.8.35 1.37-.07.58-.32 1.3-.7 2.09a24.74 24.74 0 0 1-3.77 5.42 24.74 24.74 0 0 1-4.95 4.38c-.74.47-1.42.8-2 .94-.56.14-1.06.12-1.4-.18-.33-.3-.42-.8-.34-1.38.07-.58.31-1.3.7-2.08a24.74 24.74 0 0 1 3.77-5.43 24.71 24.71 0 0 1 4.95-4.38c.74-.47 1.42-.8 2-.94Zm.86.8c-.03-.02-.18-.11-.66 0-.45.12-1.04.4-1.75.84-1.4.88-3.1 2.36-4.77 4.23a23.97 23.97 0 0 0-3.65 5.23 6.44 6.44 0 0 0-.62 1.84c-.06.49.05.63.07.65.03.02.18.12.66 0a6.47 6.47 0 0 0 1.75-.84c1.4-.88 3.1-2.36 4.77-4.23a23.95 23.95 0 0 0 3.65-5.23c.36-.75.56-1.38.62-1.84.06-.49-.05-.62-.07-.65Zm-.74-.31c.52-.13.8-.06.96.07.14.13.25.4.18.93a6.78 6.78 0 0 1-.65 1.94 24.25 24.25 0 0 1-3.7 5.31 24.32 24.32 0 0 1-4.85 4.3c-.72.45-1.35.74-1.85.87s-.8.06-.95-.07c-.14-.14-.25-.42-.18-.94.07-.51.29-1.17.65-1.94a24.25 24.25 0 0 1 3.7-5.3 24.26 24.26 0 0 1 4.85-4.3 6.77 6.77 0 0 1 1.84-.88Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M318.22 171.78a24.13 24.13 0 0 0-4.26-4.8 24.08 24.08 0 0 0-5.27-3.68 6.6 6.6 0 0 0-1.89-.64c-.5-.06-.72.05-.8.13-.07.09-.15.3-.03.8.12.48.4 1.1.85 1.8.9 1.42 2.39 3.14 4.27 4.81a24.13 24.13 0 0 0 5.27 3.68c.76.36 1.4.57 1.89.63.5.07.71-.04.79-.12.07-.1.16-.31.03-.8a6.63 6.63 0 0 0-.85-1.8Zm1.19 2.94c.98-1.1-1.32-4.73-5.12-8.12-3.8-3.38-7.68-5.24-8.66-4.14-.97 1.1 1.32 4.73 5.13 8.11 3.8 3.39 7.68 5.24 8.65 4.15Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M306.54 165.57c.92 1.45 2.43 3.2 4.32 4.88 1.9 1.69 3.8 2.99 5.35 3.73.78.37 1.46.6 2 .66.54.07.89-.02 1.08-.23.19-.22.24-.58.1-1.1a6.93 6.93 0 0 0-.89-1.9 24.45 24.45 0 0 0-4.32-4.88 24.43 24.43 0 0 0-5.35-3.73 6.92 6.92 0 0 0-1.99-.67c-.54-.07-.9.03-1.08.24-.2.21-.24.58-.11 1.1.13.53.43 1.17.9 1.9Zm-1.21-1.81c-.14-.57-.12-1.07.18-1.4.3-.35.8-.43 1.38-.35.58.07 1.3.31 2.08.7 1.59.75 3.52 2.07 5.43 3.77a24.74 24.74 0 0 1 4.38 4.95c.47.74.8 1.42.94 2 .14.56.11 1.06-.19 1.4-.3.33-.8.42-1.37.34a7.27 7.27 0 0 1-2.09-.7 24.76 24.76 0 0 1-5.42-3.77 24.74 24.74 0 0 1-4.39-4.95 7.28 7.28 0 0 1-.93-2Zm.8-.86c-.02.03-.12.18 0 .65.12.45.39 1.05.83 1.75.89 1.4 2.37 3.12 4.24 4.78a23.95 23.95 0 0 0 5.23 3.65c.75.36 1.38.56 1.84.62.48.06.62-.05.65-.07.02-.03.11-.18 0-.66a6.47 6.47 0 0 0-.84-1.75 23.9 23.9 0 0 0-4.23-4.77 23.95 23.95 0 0 0-5.24-3.65 6.47 6.47 0 0 0-1.83-.62c-.49-.07-.63.05-.65.07Zm-.32.73c-.13-.51-.06-.8.07-.95.14-.15.42-.25.94-.18.51.07 1.17.28 1.94.65 1.53.73 3.42 2.02 5.3 3.7a24.3 24.3 0 0 1 4.3 4.85c.45.72.75 1.34.87 1.84.13.52.06.8-.07.96-.13.14-.41.25-.94.18a6.75 6.75 0 0 1-1.93-.66 24.25 24.25 0 0 1-5.31-3.7 24.23 24.23 0 0 1-4.3-4.84 6.77 6.77 0 0 1-.87-1.85Z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m294.86 185.8 9-14.94 7.23 6.43-13.8 10.68c-.38.29-.91.27-1.27-.04l-.97-.87a.99.99 0 0 1-.2-1.25Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M286.35 165.1a8.66 8.66 0 0 0 0 17.35h10.32a1.3 1.3 0 1 0 0-2.62h-5.89v-1.06h9.57a1.3 1.3 0 0 0 0-2.62h-8.1v-1.06h9.57a1.3 1.3 0 0 0 0-2.62h-9.57v-1.06h7.73a1.3 1.3 0 1 0 0-2.62h-12.7v-1.06h4.97a1.3 1.3 0 0 0 0-2.62v-1.07a2.37 2.37 0 0 1 1.98 3.69h5.75a2.37 2.37 0 0 1 1.98 3.68 2.37 2.37 0 0 1 .34 4.7 2.37 2.37 0 0 1-1.95 3.72h-1.7a2.37 2.37 0 0 1-1.98 3.68h-10.32a9.73 9.73 0 0 1 0-19.47h5.9v1.07h-5.9Z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M286.33 165.12a8.66 8.66 0 0 0 0 17.34h10.33a1.3 1.3 0 0 0 0-2.62h-5.9v-1.06h9.58a1.3 1.3 0 0 0 0-2.62h-8.1v-1.06h9.57a1.3 1.3 0 1 0 0-2.62h-9.57v-1.06h7.73a1.3 1.3 0 1 0 0-2.62h-12.7v-1.06h4.97a1.3 1.3 0 1 0 0-2.62h-5.9Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M334.9 141.84a4.25 4.25 0 0 0-8.22 2.2l-1.66.45a5.97 5.97 0 0 1 11.54-3.09l-1.66.44ZM361.5 137a4.25 4.25 0 1 0-8.35 1.62l-1.7.33a5.97 5.97 0 0 1 11.73-2.28l-1.69.33ZM331.64 160.03c4.7.3 11.04-.28 17.88-1.79 6.83-1.51 12.82-3.67 16.96-5.92a18.92 18.92 0 0 0 4.63-3.29c1.01-1.06 1.26-1.88 1.13-2.44l1.68-.37c.31 1.41-.42 2.8-1.56 4a20.58 20.58 0 0 1-5.06 3.62c-4.32 2.34-10.46 4.54-17.41 6.08-6.95 1.54-13.45 2.13-18.36 1.83a20.53 20.53 0 0 1-6.11-1.15c-1.54-.6-2.8-1.55-3.1-2.96l1.68-.37c.12.56.68 1.2 2.05 1.73 1.33.53 3.23.89 5.59 1.03Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 76.8,
    height: 79.8,
    x: 1.87,
    y: 18.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2019_29295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2019_29295",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_2019_29295",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 40.47,
    height: 43.47,
    x: 55.16,
    y: 1.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2019_29295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2019_29295",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_2019_29295",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 76.8,
    height: 79.8,
    x: 558.87,
    y: 80.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2019_29295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2019_29295",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_2019_29295",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 40.47,
    height: 43.47,
    x: 612.16,
    y: 63.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2019_29295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2019_29295",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_2019_29295",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 60.17,
    x2: 20.06,
    y1: 36.83,
    y2: 76.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 60.17,
    x2: 20.06,
    y1: 36.83,
    y2: 76.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 86.19,
    x2: 64.28,
    y1: 10.96,
    y2: 32.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 86.19,
    x2: 64.28,
    y1: 10.96,
    y2: 32.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 617.17,
    x2: 577.06,
    y1: 98.83,
    y2: 138.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 617.17,
    x2: 577.06,
    y1: 98.83,
    y2: 138.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 643.19,
    x2: 621.28,
    y1: 72.96,
    y2: 94.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 643.19,
    x2: 621.28,
    y1: 72.96,
    y2: 94.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 72.98 227.85) scale(41.8308)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 96.74 251.61) scale(41.8747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 392.82,
    x2: 390.29,
    y1: 154.46,
    y2: 156.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 350.01,
    x2: 352.55,
    y1: 183.04,
    y2: 180.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 392.02,
    x2: 389.07,
    y1: 157.65,
    y2: 160.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 350.81,
    x2: 353.76,
    y1: 179.85,
    y2: 176.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.29466 9.73454 -13.78378 -6.0811 377.34 173.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.12573 5.4705 -7.74606 -12.92172 325.28 179.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 318.6,
    x2: 306.34,
    y1: 161.76,
    y2: 175.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(70.23 19.88 290.88) scale(10.3588 14.6677)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.1aeff9f0d4511f45e16e160731103875.svg";
export { ForwardRef as ReactComponent };